import React from 'react';
import clsx from 'clsx';

interface Props {
  className?: string;
  children?: React.ReactNode;
  [key: string]: any;
}

const Warning: React.FC<Props> = ({ className, children, ...props }) => {
  if (!children) return null;

  // Handle string content with line breaks
  if (typeof children === 'string') {
    return (
      <div
        aria-atomic="true"
        aria-live="polite"
        className={clsx(
          'block text-yellow-600 text-xs leading-5 min-h-[16px] whitespace-pre-line',
          className,
        )}
        {...props}
      >
        {children}
      </div>
    );
  }

  // Handle other content types
  return (
    <div
      aria-atomic="true"
      aria-live="polite"
      className={clsx(
        'block text-yellow-600 text-xs leading-5 min-h-[16px] whitespace-normal',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

export default Warning;
